export enum CardBrandType {
    Unknown = 'unknown',
    Mastercard = 'mastercard',
    Visa = 'visa',
}